import { CommonModule } from '@angular/common';
import { Component, computed, OnInit, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { AuthService } from '../../../core/services/auth.service';
import { NavigationService } from '../../../core/services/navigation.service';
import { InvitationDetailsService } from '../../../core/services/invitation-details.service';
import { LogoutComponent } from '../logout/logout.component';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { AppRoutes, ROUTE_PATHS } from '../../constants/app-routes';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatDialogModule,
    TranslatePipe
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  public canGoBack = computed(() => this.navigationService.canGoBack());
  public showUserMenu = signal(false);
  public isAuthenticated = computed(() => this.authService.isAuthenticated());
  public currentUser = computed(() => this.authService.currentUser());
  public isInDetailsView = computed(() => this.invitationDetailsService.isInDetailsView());
  
  // Detectar si estamos en home (para botón filled)
  public isInHomeView = computed(() => {
    const currentPath = this.navigationService.currentPath();
    return currentPath === '/' + ROUTE_PATHS[AppRoutes.HOME] || currentPath === '/';
  });

  // Detectar si estamos en invitations o entries (para botón outline)
  public showOutlineCreateButton = computed(() => {
    const currentPath = this.navigationService.currentPath();
    return currentPath === '/' + ROUTE_PATHS[AppRoutes.INVITATIONS] || 
           currentPath === '/' + ROUTE_PATHS[AppRoutes.ENTRIES];
  });

  // Mostrar botón filled en home
  public showFilledCreateButton = computed(() => {
    return this.isInHomeView() && !this.isInDetailsView();
  });

  // Mostrar botón outline en invitations/entries
  public showOutlineButton = computed(() => {
    return this.showOutlineCreateButton() && !this.isInDetailsView();
  });

  constructor(
    private authService: AuthService,
    private navigationService: NavigationService,
    private invitationDetailsService: InvitationDetailsService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {}

  goBack(): void {
    this.navigationService.goBack();
  }

  changePassword(): void {
    this.navigationService.goToChangePassword();
  }

  personalInformation(): void {
    this.navigationService.goToPersonalInformation();
  }

  logout(): void {
    const dialogRef = this.dialog.open(LogoutComponent, {
      width: '100%',
      maxWidth: '100%',
      height: 'auto',
      maxHeight: '100%',
      disableClose: false,
      panelClass: 'app-container-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.authService.logout();
      }
    });
  }

  getPageTitle(): string {
    return this.navigationService.getPageTitle();
  }

  createInvitation(): void {
    this.navigationService.goToCreate();
  }

  shareInvitation(): void {
    this.invitationDetailsService.emitShareAction();
  }

  deleteInvitation(): void {
    this.invitationDetailsService.emitDeleteAction();
  }
}

